// extracted by mini-css-extract-plugin
module.exports = {"container":"Banner_container__3jnmt","container__coloured":"Banner_container__coloured__2cuei","banner":"Banner_banner__2xv48","form":"Banner_form__3NuqU"};